<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-left">
            <h3>{{ $t('force.activateSuccess.title') }}</h3>
        </div>

        <div class="text-left mt-4 card card-pricing text-center">
            <div class="card-body">
                <p class="card-text">
                    {{ $t('force.activateSuccess.message') }}
                </p>
                <router-link :to="{ name: 'messages' }" class="btn btn-primary pr-5 pl-5 force-club-activate-success-module-button-label">
                    {{ $t('force.activateSuccess.closeBtn') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'forceTabActivateSuccess',

        components: {},

        mounted() {},

        data() {
            return {}
        },

        methods: {}
    }
</script>

<style>
    .force-club-activate-success-module-button-label {
        white-space: nowrap;
    }
</style>
